import shortid from "shortid"
import * as Objdict from "objdict"
import Geometry from "@frog/source/utility/Geometry.js"
import * as Motions from "@frog/source/juice/utility/Motions.js"
import Timings from "@frog/source/juice/utility/Timings.js"
import Random from "@frog/source/utility/Random.js"
import sizes from "@frog/source/data/sizes.js"

import Colors from "@frog/source/data/colors.js"
import Unit from "@frog/source/models/Unit.js"

import Navigation from "@frog/source/models/Navigation.js"

const animations = {}
export default animations

function Count(count) {
    let array = []
    for(let i = 0; i < count; i += 1) {
        array.push(i)
    }
    return array
}

function FlyInFlyOut({image, flyIn = true, flyOut = true, duration = 750, key}) {
    const OFFSET = sizes.frame.width
    key = key || shortid.generate()
    return [
        flyIn && {
            "key": key,
            "type": "particle",
            "space": "screenspace",
            "mark": 0,
            "image": image,
            "stack": 9999999,
            "position": {
                "x": 0 - OFFSET,
                "y": (sizes.frame.height / 2),
                // "x": sizes.frame.width / 2,
                // "y": sizes.frame.height / 2,
            },
            "anchor": {
                "x": "50%",
                "y": "50%"
            },
        },
        flyIn && {
            "key": key,
            "type": "particle",
            "mark": duration * (1/3),
            "timing": Timings.easeOutQuad,
            "position": {
                "x": (sizes.frame.width / 4),
                "y": (sizes.frame.height / 2),
            }
        },
        flyIn && {
            "key": key,
            "type": "particle",
            "mark": duration * (2/3),
            "position": {
                "x": (sizes.frame.width / 4),
                "y": (sizes.frame.height / 2),
            }
        },
        flyOut && {
            "key": key,
            "type": "particle",
            "mark": duration,
            "timing": Timings.easeInQuad,
            "position": {
                "x": sizes.frame.width + OFFSET,
                "y": (sizes.frame.height / 2),
            }
        },
    ]
}

// const endTurnFadeAnimation = require("@frog/source/assets/images/hero-tactics/ui/fe-end-turn-fade/animation.js")

const BANNER_BAD = require("@frog/source/assets/images/apocalypse-tactics/ui/banners/enemy-turn.png").default
const BANNER_GOOD = require("@frog/source/assets/images/apocalypse-tactics/ui/banners/your-turn.png").default
animations["start turn"] = (step) => {
    return {
        "keyframes": [
            FlyInFlyOut({
                "image": step.affiliation == "bad" ? BANNER_BAD : BANNER_GOOD
            }),
        ]
    }
}

animations["encounter failure"] = (step) => {
    return {
        "keyframes": [
            FlyInFlyOut({
                "image": require("@frog/source/assets/images/apocalypse-tactics/ui/banners/lose.png").default,
                "flyOut": false,
            }),
            {
                "mark": 0,
                "audio": {"triggerKey": "Music:Failure"},
            },
            {
                "mark": Infinity,
            }
        ]
    }
}

animations["encounter success"] = (step) => {
    return {
        "keyframes": [
            FlyInFlyOut({
                "key": "success",
                "image": require("@frog/source/assets/images/apocalypse-tactics/ui/banners/win.png").default,
                "duration": 100,
                "flyOut": false,
            }),
            // {
            //     "key": "success",
            //     "type": "particle",
            //     "space": "screenspace",
            //     "mark": 1000,
            //     "image": require("@frog/source/assets/images/leviathan-tactics/ui/banner-success-1.png").default,
            // },
            // {
            //     "key": "success",
            //     "type": "particle",
            //     "space": "screenspace",
            //     "mark": 1000,
            //     "image": require("@frog/source/assets/images/leviathan-tactics/ui/banner-success-2.png").default,
            // },
            // {
            //     "key": "success",
            //     "type": "particle",
            //     "space": "screenspace",
            //     "mark": 1000,
            //     "image": require("@frog/source/assets/images/leviathan-tactics/ui/banner-success-3.png").default,
            // },


            {
                "mark": 0,
                "audio": {"triggerKey": "Music:Success"},
            },
            {
                "mark": Infinity,
            },
        ]
    }
}

animations["encounter start"] = (step) => {
    return {
        "keyframes": [
            FlyInFlyOut({
                "image": require("@frog/source/assets/images/apocalypse-tactics/ui/banners/lets-go.png").default,
                "duration": 1000,
            }),
        ]
    }
}

animations["navigate"] = (step) => {
    return {
        "keyframes": [
            {
                "mark": 0,
                "do": function() {
                    console.log(step.path, step.data)
                    Navigation.go(step.path, step.data)
                }
            }
        ]
    }
}

animations["move-encounter"] = (step) => {
    return {
        "keyframes": [
            {
                "currentEncounter": step.currentEncounter,
            }
        ]
    }
}

animations["move"] = (step) => {
    return {
        "keyframes": step.deltastages.map((deltastage) => {
            return Object.values(Objdict.map(deltastage.units, (unit, unitKey) => {
                const a = step.alphastage.units[unitKey].position
                const b = step.omegastage.units[unitKey].position
                const protounit = units["class:" + step.alphastage.units[unitKey].class] || {}
                return [
                    {
                        "mark": 0,
                        "unit": {
                            "key": unitKey,
                            "position": a,
                        }
                    },
                    {
                        "mark": 150,
                        "timing": Timings.easeOutQuad,
                        "motion": Motions.arc(0.5),
                        "unit": {
                            "key": unitKey,
                            "position": b
                        }
                    },
                    {
                        "mark": 0,
                        "audio": {
                            "triggerKey": protounit.moveaudio || "Unit:Move:Infantry"
                        },
                    },

                    // units[deltastage.annotation.unitReference].images.sprites.move.map((frame) => {
                    //     return {
                    //         "key": deltastage.unit.key,
                    //         "mark": 150 / frame.index,
                    //         "image": frame.image,
                    //     }
                    // }),
                ]
            }))
        })
    }
}

animations["death"] = (step) => {
    return {
        "keyframes": step.deltastages.map((deltastage) => {
            return Object.values(Objdict.map(deltastage.units, (unit, unitKey) => {
                if(deltastage.annotation.type == "death-by-damage") {
                    return [
                        {
                            "mark": 0,
                            "audio": {"triggerKey": "Unit:Death"},
                        },
                        {
                            "mark": 0,
                            "unit": {
                                "key": unitKey,
                                "opacity": 1,
                            }
                        },
                        {
                            "mark": 300,
                            "unit": {
                                "key": unitKey,
                                "opacity": 0,
                            }
                        },
                        {
                            "mark": 500,
                        },
                    ]
                }
                if(deltastage.annotation.type == "death-by-falling") {
                    return [
                        {
                            "mark": 0,
                            "audio": {"triggerKey": "Unit:Death"},
                        },
                        {
                            "mark": 0,
                            "unit": {
                                "key": unitKey,
                                "position": {
                                    "x": deltastage.annotation.position.x,
                                    "y": deltastage.annotation.position.y,
                                    "z": deltastage.annotation.position.z
                                }
                            }
                        },
                        {
                            "mark": 300,
                            "timing": Timings.easeInQuad,
                            "unit": {
                                "key": unitKey,
                                "position": {
                                    "x": deltastage.annotation.position.x,
                                    "y": deltastage.annotation.position.y,
                                    "z": deltastage.annotation.position.z - 10
                                }
                            }
                        },
                    ]
                }
            }))
        })
    }
}

// requires a direction and unit.key
function NudgedMovement(deltastage) {
    return [
        {
            "mark": deltastage.mark + 0,
            "unit": {
                "key": deltastage.flourish.unit.key,
                "position": deltastage.flourish.position,
            }
        },
        {
            "mark": deltastage.mark + 150,
            "timing": Timings.easeOutQuad,
            "unit": {
                "key": deltastage.flourish.unit.key,
                "position": Geometry.add(deltastage.flourish.position, Geometry.multiply(deltastage.flourish.direction, 0.25)),
            }
        },
        {
            "mark": deltastage.mark + 200,
            "timing": Timings.easeInQuad,
            "unit": {
                "key": deltastage.flourish.unit.key,
                "position": deltastage.flourish.position,
            }
        },
    ]
}

// requires a mark, unit.key, unit.startPosition and unit.endPosition
function PushedMovement(deltastage) {
    const mark = deltastage.mark ?? 0
    const endmark = deltastage.endmark ?? (mark + 250)
    const direction = Geometry.direction(deltastage.flourish.startPosition, deltastage.flourish.endPosition)
    return [
        {
            "mark": mark,
            "unit": {
                "key": deltastage.flourish.unit.key,
                "position": deltastage.flourish.startPosition,
            }
        },
        {
            "mark": endmark - 50,
            "timing": Timings.easeOutQuad,
            "unit": {
                "key": deltastage.flourish.unit.key,
                "position": Geometry.add(deltastage.flourish.endPosition, Geometry.multiply(direction, -0.25)),
            }
        },
        {
            "mark": endmark,
            "timing": Timings.easeInQuad,
            "unit": {
                "key": deltastage.flourish.unit.key,
                "position": deltastage.flourish.endPosition,
            }
        },
    ]
}

// requires a direction and unit.key
function SwingBackMovement(deltastage) {
    const position = deltastage.flourish.position
    const backDirection = Geometry.multiply(deltastage.flourish.direction, -0.25)
    const forwardDirection = Geometry.multiply(deltastage.flourish.direction, +0.125)
    return [
        {
            "mark": deltastage.mark + 0,
            "unit": {
                "key": deltastage.flourish.unit.key,
                "position": position,
            }
        },
        {
            "mark": deltastage.mark + 25,
            "unit": {
                "key": deltastage.flourish.unit.key,
                "position": Geometry.add(position, backDirection),
            }
        },
        {
            "mark": deltastage.mark + 200,
            "unit": {
                "key": deltastage.flourish.unit.key,
                "position": Geometry.add(position, backDirection),
            }
        },
        {
            "mark": deltastage.mark + 300,
            "unit": {
                "key": deltastage.flourish.unit.key,
                "position": Geometry.add(position, forwardDirection),
            }
        },
        {
            "mark": deltastage.mark + 300 + 50,
            "unit": {
                "key": deltastage.flourish.unit.key,
                "position": Geometry.add(position, forwardDirection),
            }
        },
        {
            "mark": deltastage.mark + 300 + 150,
            "unit": {
                "key": deltastage.flourish.unit.key,
                "position": position,
            }
        },
    ]
}

function JumpMovement(deltastage) {
    return [
        {
            "mark": deltastage.mark,
            "unit": {
                "key": deltastage.flourish.unit.key,
                "position": deltastage.flourish.startPosition,
            }
        },
        {
            "mark": deltastage.endmark,
            "motion": Motions.arc(4.5),
            "timing": Timings.bezier(0, 1 - 0.2, 1, 0 + 0.2),
            "unit": {
                "key": deltastage.flourish.unit.key,
                "position": deltastage.flourish.endPosition,
            }
        }
    ]
}

function SpriteFrameAnimation(deltastage) {
    const animation = units[deltastage.flourish.unit.class]?.images?.sprites[deltastage.flourish.spriteSet]
    if(animation == undefined) {
        return
    }
    return animation.frames.map((frame) => {
        return {
            "key": deltastage.flourish.unit.key,
            "mark": deltastage.mark + frame.time,
            "image": frame.image,
        }
    })
}

function CombatSequence(deltastage) {
    const animation = units["class:" + deltastage.flourish.unit.class]?.images?.sprites?.combat
    if(animation != undefined) {
        const key = shortid.generate()
        return animation.frames.map((frame) => {
            return {
                "key": key,
                "type": "particle",
                "mark": deltastage.mark + frame.time,
                "image": frame.image,
                "position": {"x": -6, "y": -2},
            }
        })
    }
}

function TextFloat(deltastage) {
    const key = shortid.generate()
    return [
        {
            "key": key,
            "type": "particle",
            "mark": deltastage.mark,
            "text": {
                "string": deltastage.flourish.text,
                "font": deltastage.flourish.font || "numbers",
            },
            "position": Geometry.add(deltastage.flourish.position, {"y": -0.5}),
        },
        {
            "key": key,
            "type": "particle",
            "mark": deltastage.mark + 600,
            "timing": Timings.easeInQuad,
            "position": Geometry.add(deltastage.flourish.position, {"y": -1.5}),
        },

        {
            "key": key,
            "type": "particle",
            "mark": deltastage.mark + 250,
            "opacity": 1,
        },
        {
            "key": key,
            "type": "particle",
            "mark": deltastage.mark + 500,
            "timing": Timings.easeOutQuad,
            "opacity": 0,
        },
    ]
}

function Audio(deltastage) {
    return {
        "mark": deltastage.mark,
        "audio": deltastage.flourish.audio,
    }
}

import {units} from "@frog/source/data/units.js"

const flourishes = {
    SwingBackMovement,
    JumpMovement,
    NudgedMovement,
    PushedMovement,
    CombatSequence,
    SpriteFrameAnimation,
    TextFloat,
    Audio,
}

animations["invoke skill"] = (step) => {
    return {
        "isImportant": true,
        "keyframes": step.deltastages.map((deltastage) => {
            // if(deltastage.mark == undefined) {
            //     return undefined
            // }
            deltastage.mark = deltastage.mark || 0
            if(deltastage instanceof Function) {
                return deltastage()
            }
            if(deltastage.isSkipped == true) return
            if(deltastage.flourish != undefined
            && flourishes[deltastage.flourish.name] != undefined) {
                return flourishes[deltastage.flourish.name](deltastage)
            } else {
                return deltastage // just naively performs it
                // TODO: I wish the naive perform of it would include a delta.editStage, right??
                // I currently have to rewrite the setting of properties in the Director.performStage :<
                // I get that I need to tween it! But this is different, right?
            }
        })
    }
}
